import { render, staticRenderFns } from "./ButtonView.vue?vue&type=template&id=d05ca764&scoped=true&"
import script from "./ButtonView.vue?vue&type=script&lang=js&"
export * from "./ButtonView.vue?vue&type=script&lang=js&"
import style0 from "./ButtonView.vue?vue&type=style&index=0&id=d05ca764&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05ca764",
  null
  
)

export default component.exports